import React, { useCallback } from 'react';
import { DomUtils } from '@vectord/utils';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import styles from './UploadVideoTableBody.module.scss';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import toDDMMMYYYYHHMM from 'utils/toDDMMMYYYYHHMM';

export default function UploadVideoTableBody({ uploadedVideos }) {
  const copyToboard = useCallback((id) => {
    DomUtils.copyToClipboard(id);
    cogoToast.success('Video ID has been copied!');
  }, []);

  return (
    <TableBody>
      {uploadedVideos?.map(
        ({
          id,
          asset_file_name: assetFileName,
          asset_updated_at: assetUpdatedAt,
          link,
        }) => (
          <TableRow
            key={`video-${id}`}
            className={styles.root}
          >
            <TableCell>{assetFileName}</TableCell>
            <TableCell>{toDDMMMYYYYHHMM(assetUpdatedAt)}</TableCell>
            <TableCell>
              <Tappable
                className={classNames('link', styles.videoLink)}
                href={link}
                noHighlight
                target="_blank"
              >
                Watch Video
              </Tappable>
            </TableCell>
            <TableCell>
              <span className="m-r-20">{id}</span>
              <Tappable
                onClick={() => copyToboard(id)}
                className={styles.videoId}
                noHighlight
              >
                <Icon
                  name="copy"
                  className={styles.videoIdIcon}
                />
                Copy ID
              </Tappable>
            </TableCell>
          </TableRow>
        )
      )}
    </TableBody>
  );
}
